import { OrderFiltersType } from "../../../../graphql/types/OrderFiltersType";

/**
 * 历史包裹查询页删掉的异常信息 7 项筛选条件。
 *
 * 其中只有 exceptionStatuses 来自 exception_order 表（历史索引不写该字段），
 * 另外 6 项来自 order 表、数据其实在历史索引里。全删是产品决策——异常信息作为一个整体
 * 从历史查询中移除；要恢复的话索引侧零改动，从这个清单里去掉 + 前端加回筛选项即可。
 */
const EXCEPTION_FILTER_KEYS = [
    'isAbnormal',
    'isHasBeenSetException',
    'exceptionReasonCode',
    'markExceptionAt',
    'nextAction',
    'nextActions',
    'exceptionStatuses'
] as const;

/** 剥掉异常筛选条件，不改原对象 */
export const stripExceptionFilters = (filters: OrderFiltersType): OrderFiltersType => {
    const cleaned: any = { ...filters };
    EXCEPTION_FILTER_KEYS.forEach((key) => {
        delete cleaned[key];
    });
    return cleaned as OrderFiltersType;
};

export { EXCEPTION_FILTER_KEYS };
